function giftWithPurchaseMutation() {
  const config = window.giftWithPurchaseConfig;
  if (!config) return;

  const cart = window.liquidAjaxCart.cart;
  const giftIndex = cart.items.findIndex(item => item.properties?._gift === 'Yes');

  if (!config.enabled) {
    // GWP paused for this market — remove the gift if a shopper already has it in cart
    if (giftIndex > -1) {
      return { requests: [{ type: "change", body: { line: giftIndex + 1, quantity: 0 } }] };
    }
    return;
  }

  const declined = cart.attributes?.gift_declined === 'true';
  let subtotal = cart.total_price;
  if (giftIndex > -1) {
    subtotal -= cart.items[giftIndex].final_line_price;
  }

  if (subtotal < config.threshold) {
    const requests = [];
    if (giftIndex > -1) requests.push({ type: "change", body: { line: giftIndex + 1, quantity: 0 } });
    if (declined) requests.push({ type: "update", body: { attributes: { gift_declined: "" } } });
    if (requests.length) return { requests };
    return;
  }

  if (declined) return;
  if (giftIndex === -1) {
    return {
      requests: [{
        type: "add",
        body: { items: [{ id: config.giftVariantId, quantity: 1, properties: { _gift: "Yes" } }] }
      }]
    };
  }
}

function registerGiftMutation() {
  if (window.liquidAjaxCart && window.liquidAjaxCart.conf) {
    window.liquidAjaxCart.conf('mutations', [giftWithPurchaseMutation]);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.liquidAjaxCart && window.liquidAjaxCart.conf) {
        window.liquidAjaxCart.conf('mutations', [giftWithPurchaseMutation]);
      } else {
        console.error('Liquid Ajax Cart: library not found — gift mutation not registered.');
      }
    });
  }
}

registerGiftMutation();

document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-decline-gift]');
  if (!btn) return;
  event.preventDefault();
  const line = Number(btn.getAttribute('data-decline-gift-line'));
  if (!line || !window.liquidAjaxCart) return;
  window.liquidAjaxCart.change({ line: line, quantity: 0 }, { info: { initiator: btn } });
  window.liquidAjaxCart.update({ attributes: { gift_declined: 'true' } }, { info: { initiator: btn } });
});